import {
  REQUEST,
  RESPONSE,
  FAILURE,
  CLEAR
} from '../../actions/segments/preview';

const initialState = {
  isLoading: false,
  response: null,
  error: null,
  currentPage: 1,
  pageSize: 100
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        // Update current page if it's in the payload
        currentPage: action.payload.page || state.currentPage,
        pageSize: action.payload.page_size || state.pageSize
      };

    case RESPONSE:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null
      };

    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case CLEAR:
      return initialState;

    default:
      return state;
  }
};
